import type {
  BorderWidths,
  CheckoutShadows,
  OffersPageShadows,
  Radii,
  Shadows,
} from '@trmediaab/zebra';

const borderWidths: BorderWidths = {
  0: 0,
  1: 1,
};

const radii: Radii = {
  1: 4,
};

const shadows: Shadows & CheckoutShadows & OffersPageShadows = {
  textInput: 'inset 0 1px 3px 0 rgba(221, 221, 221, 0.5)',
  textInputFocus: 'inset 0 0px 4px 0 rgba(153, 153, 153, 0.4)',

  checkout: {
    box: '0 2px 5px 0 rgba(182, 182, 182, 0.5)',
  },

  offersPage: {
    productBox: '0 2px 5px 0 rgba(182, 182, 182, 0.5)',
  },
};

export { borderWidths, radii, shadows };
